import name from './name'

const selectSliceData = state => state[name]
const selectPages = state => selectSliceData(state).pages

export {
  selectPages
}
